import { createAsyncThunk, createReducer } from "@reduxjs/toolkit";

import { fetchWithAuth } from "~/common/fetch";
import { API_GET_BONUSES } from "~/config";
import type { RootState } from "~/store";
import type { DateTimeString } from "~/types/common";
import type { MutableQueryState } from "~/types/redux";
import type { TUser } from "~/types/user";

export type TBonuses = {
  available: number;
  current: number;
  days: number | null;
  end: DateTimeString | null;
  months: number | null;
  start: DateTimeString | null;
  target: number;
  total: number;
  used: number;
};

const initialState: MutableQueryState<TBonuses> = {
  status: "idle",
  data: undefined,
  error: undefined,
};

export const getBonuses = createAsyncThunk(
  "bonuses/fetch",
  async (doctor_id: TUser["account_id"]) => {
    const response = await fetchWithAuth(API_GET_BONUSES(doctor_id));

    if (!response.ok) {
      throw new Error("Error occurred trying to fetch bonuses");
    }

    return (await response.json()) as TBonuses;
  },
);

export const selectBonuses = (state: RootState): TBonuses | undefined => state.bonuses.data;

export const bonuses = createReducer(initialState, (builder) =>
  builder
    .addCase(getBonuses.pending, (state) => {
      state.status = "loading";
    })
    .addCase(getBonuses.fulfilled, (state, action) => {
      state.status = "success";
      state.data = action.payload;
      state.error = undefined;
    })
    .addCase(getBonuses.rejected, (state, action) => {
      state.status = "error";
      state.data = undefined;
      state.error = action.error;
    }),
);
